import type { ActionAdderContextValue } from '@/contexts/ActionAdderContext'
import { useActionAdderContext } from '@/contexts/ActionAdderContext'

import { useVariableCustomViewOption } from './useVariableCustomViewOption'

export const useActionAdderDepParams = (): ActionAdderContextValue => {
    const { customViewOption } = useVariableCustomViewOption()
    const actionAdderCtxValue = useActionAdderContext()
    return {
        viewDsId: actionAdderCtxValue?.viewDsId || customViewOption?.value,
        viewType: actionAdderCtxValue?.viewType || 'custom',
        formDsId: actionAdderCtxValue?.formDsId,
        isImage: actionAdderCtxValue?.isImage
    }
}
